// Imports
import React from 'react';
import GlobalStyle from './shareables/foundation/simple-ui/components/global-style';
import Header from './shareables/foundation/simple-ui/components/header';
import Box from './shareables/foundation/simple-ui/components/box';
import Footer from './footer';
import Logo from './shareables/front-end/svg-logo';
import company from './shareables/company';


// Component class
//  -> There are no Hooks for error boundary functions yet (https://reactjs.org/docs/error-boundaries.html)
class ErrorBoundary extends React.Component<
	{ children: React.ReactChild; storybookError?: true },
	{ hasError: boolean }
> {
	constructor(props: { children: React.ReactChild; storybookError?: true }) {
		super(props);
		this.state = { hasError: props.storybookError ?? false };
	}
	
	static getDerivedStateFromError() {
		return { hasError: true };
	}
	
	render() {
		if (this.state.hasError) {
			return (
				<React.StrictMode>
					<GlobalStyle />
					
					<Header
						logoElement={
							(window as typeof window & { STORYBOOK?: true }).STORYBOOK ? (
								<img src='/images/placeholders/400x100.png' alt='Placeholder logo' />
							) : (
								<Logo />
							)
						}
						title='Sign in'
					/>
					
					<Box>
						<strong>Oh snap!</strong> An unexpected issue occurred.
						{company.productionDomain && (
							<React.Fragment>
								{' '}
								If this persists, please{' '}
								<a href={`https://help.${company.productionDomain}/`} target='_blank' rel='noopener noreferrer'>
									contact us
								</a>
								.
							</React.Fragment>
						)}
					</Box>
					
					<Footer />
				</React.StrictMode>
			);
		}
		
		return this.props.children;
	}
}


// Export
export default ErrorBoundary;
